<template>
<div class="m-4 p-4">
	<p v-for="(p, index) in paragraph($t('disclaimer-text'))" v-html="p" :key="index"></p>
	<h2>{{ $t('view-member-activity') }}</h2>
	
	<h3>{{ $t('for-term')}} {{ $t('term-range',{ term_from: term_from, term_to: term_to }) }} 
		<button v-if="!show_terms && terms.length > 1" type="button" class=" ml-4 btn btn-secondary btn-small" @click="show_change_term">{{ $t('change-term') }}</button>
	</h3>
	<div class="row mt-4 mb-4" v-if="show_terms">
		<div class="col-12 col-md-4">
			<label for="select-term">{{ $t('terms') }}</label>
			<select id="select-term" class="custom-select custom-select custom-select-sm" v-model="term_index">
				<option v-for="(term,index) in active_terms" :key="index" v-bind:value="index">{{ term.from.display }} - {{ term.to.display }}</option>
			</select>
		</div>
	</div>
	<div class="row mt-4 mb-4">
		<div class="col-12 col-md-4">
			<label for="select-member">{{ $t('members') }}</label>
			<select id="select-member" class="form-control" v-model="member">
				<option v-for="(member,index) in members" :key="index">{{ member }}</option>
			</select>
		</div>
	</div>
	<div class="row mt-4 mb-4">
		<div class="col-12 col-md-4">
			<label>{{ $t('filter_votes') }}</label>
			<div class="custom-control custom-radio">
				<input v-model="vote_type" type="radio" id="allVotes" class="custom-control-input" value="">
				<label class="custom-control-label" for="allVotes">{{ $t('all') }}</label>
			</div>
			<div class="custom-control custom-radio"  v-for="(vote,index) in vote_types" :key="index">
				<input v-model="vote_type" type="radio" :id="'voteType' + index" class="custom-control-input" :value="vote.vote">
				<label class="custom-control-label" :for="'voteType' + index">{{ vote.vote }}</label>
			</div>
		</div>
	</div>
	<div class="row mt-4 mb-4">
		<div class="col-12 col-md-4">
			<DatePicker element_class="" :label="$t('meetings-after')" :placeholder="$t('select-date')" :date="start_date" v-on:update="(event) => update_date(event, 'start_date')"></DatePicker>
		</div>
		<div class="col-12 col-md-4">
			<DatePicker element_class="" :label="$t('meetings-before')" :placeholder="$t('select-date')" :date="end_date" v-on:update="(event) => update_date(event, 'end_date')"></DatePicker>
		</div>
		<div class="col-12 col-md-4">
			<label for="filter-committee">{{ $t('filter-committee-more') }}</label>
			<select id="filter-committee" class="form-control" v-model="committee_name">
				<option value="">{{ $t('all') }}</option>
				<option v-for="(committee_name,index) in committees" :key="index">{{ committee_name }}</option>
			</select>
		</div>
	</div>
	<div v-if="filters.length">
		<h3>{{ $t('current-filters') }}</h3>
		<ul class="list-unstyled">
			<a v-if="committee_name" class="m-2 cursor badge badge-secondary" @click="committee_name = ''">{{ $t('committee') }} {{ committee_name }} </a>
			<a v-if="start_date" class="m-2 cursor badge badge-secondary" @click="start_date = ''">{{ $t('meetings-after') }} {{ start_date | moment($t('date-format'))}}</a>
			<a v-if="end_date" class="m-2 cursor badge badge-secondary" @click="end_date = ''">{{ $t('meetings-before') }} {{ end_date | moment($t('date-format'))}}</a>
			<a v-if="member" class="m-2 cursor badge badge-secondary" @click="member = ''">{{ $t('member') }} {{ member }}</a>
			<a v-if="vote_type" class="m-2 cursor badge badge-secondary" @click="vote_type = ''">{{ $t('ballot-cast') }} {{ vote_type }}</a>
		</ul>	
	</div>
	<table v-if="activities.length" class="table table-bordered table-striped table-hover table-sm">
		<thead>
			<tr>
				<SortableColumn :direction="direction" :column_name="'committee'" :column="column" v-on:order="order"></SortableColumn>
				<SortableColumn :direction="direction" :column_name="'meeting_date'" :column="column" v-on:order="order"></SortableColumn>
				<SortableColumn :direction="direction" :column_name="'heading'" :column="column" v-on:order="order"></SortableColumn>
				<SortableColumn :direction="direction" :column_name="'title'" :column="column" v-on:order="order"></SortableColumn>
				<th scope="col">{{ $t('vote')}}</th>
				<SortableColumn :direction="direction" :column_heading="'ballot-cast'" :column_name="'vote'" :column="column" v-on:order="order"></SortableColumn>
				<th scope="col">{{ $t('count') }}</th>
				<th scope="col">{{ $t('percentage') }}</th>
				<th scope="col">{{ $t('result') }}</th>
				<th scope="col">{{ $t('rule') }}</th>
			</tr>
		</thead>
		<tbody>
			<tr class="cursor" @click="open_meeting(row,$event)" v-for="(row,index) in activities" :key="index">
				<td>{{ row.committee_name }}</td>
				<td><router-link :to="{ name: 'meeting', params: { meeting_id: row.meeting_id }}">{{ row.meeting_date | moment($t('date-format')) }}</router-link></td>
				<td>{{ row.heading }}</td>
				<td v-if="row.minutes_section_id"><a class="inline-link" :href="'http://clkapps.winnipeg.ca/DMIS/ViewDoc.asp?DocId=' + row.minutes_doc_id + '&SectionId=' + row.minutes_section_id" target="_blank">{{ row.title || $t('no_title') }}</a></td>
				<td v-else>{{ row.title }}</td>
				<td>{{ row.vote_description }}</td>
				<td>{{ row.vote }}</td>
				<td>{{ row.yeas }} - {{ row.nays }}</td>
				<td>{{ row.yea_percent | clean_percentage }}</td>
				<td>{{ row.result }}</td>
				<td>{{ row.vote_rule }}</td>
			</tr>
		</tbody>
	</table>
	<button v-if="last_count === limit" type="button" class="mt-4 btn btn-primary" @click="view_more">{{ $t('view-more') }}</button>
</div>
</template>

<script>
import OpenData from '@/libraries/OpenData'
import DatePicker from '@/components/DatePicker'
import SortableColumn from '@/components/SortableColumn'

export default {
	components: { DatePicker, SortableColumn },
	data() {
		return {
			terms: [
				{
					from: { display: 2018, actual: '2018-10-01'},
					to: {display: 2022, actual: '2022-10-01' }
				},
				{
					from: { display: 2022, actual: '2022-10-01'},
					to: {display: 2026, actual: '2026-10-01' }
				},
				{
					from: { display: 2026, actual: '2026-10-01'},
					to: {display: 2030, actual: '2030-10-01' }
				},
				{
					from: { display: 2030, actual: '2030-10-01'},
					to: {display: 2034, actual: '2034-10-01' }
				},
			],
			limit: 100,
			offset: 0,
			term_index: 0,
			member: '',
			members: [],
			committee_name: '',
			committees: [],
			start_date: '',
			end_date: '',
			show_terms: false,
			activities: [],
			column: 'meeting_date',
			direction: 'DESC',
			last_count: 0,
			//vote_types: ['Yea','Nay','Absent','Conflict of Interest']
			vote_types: [],
			vote_type: '',
		}
	},

	created() {
		this.reset_selects();
		this.get_vote_types();
		if (this.$route.params.member) {
			this.member = this.$route.params.member;
		}
	},

	filters: {
		clean_percentage(percentage) {
			return Math.round(percentage) + '%'; 
		}
	},

	computed: {
		active_terms() {
			const now = new Date();
			return this.terms.filter(term => {
				const term_start = new Date(term.from.actual);
				return (now.getTime() > term_start.getTime());
			});
		},

		term_from() {
			return this.terms[this.term_index].from.display;
		},

		term_to() {
			return this.terms[this.term_index].to.display;
		},

		term_clause() {
			let where_parameters = [];
			const from_date = this.terms[this.term_index].from.actual;
			const to_date = this.terms[this.term_index].to.actual;
			where_parameters.push([{column: 'meeting_date', type: '>=', params: [from_date]}]);
			where_parameters.push([{column: 'meeting_date', type: '<=', params: [to_date]}]);
			return where_parameters;
		},

		order_parameters() {
			return [{key: this.column, direction: this.direction }];
		},

		parameters() {
			let where_parameters = this.filters;
			let order_parameters = this.order_parameters;
			let limit_parameters = {limit: this.limit, offset: this.offset };
			return { where_parameters, order_parameters, limit_parameters }
		},

		filters() {
			let where_parameters = JSON.parse(JSON.stringify(this.term_clause));
			if (this.committee_name) {
				where_parameters.push([{column: 'committee_name', type: '=', params: [this.committee_name]}]);
			}
			if (this.start_date) {
				where_parameters.push([{column: 'meeting_date', type: '>=', params: [this.start_date]}]);
			}
			if (this.end_date) {
				where_parameters.push([{column: 'meeting_date', type: '<=', params: [this.end_date]}]);
			}
			if (this.member) {
				where_parameters.push([{column: 'member', type: '=', params: [this.member]}]);
			}
			if (this.vote_type) {
				where_parameters.push([{column: 'vote', type: '=', params: [this.vote_type]}]);
			}
			return where_parameters;
		}
	},

	watch: {
		term_index() {
			this.reset_selects();
		},

		filters() {
			this.offset = 0;
			this.last_count = 0;
			this.activities = [];
			if (this.member) {
				this.get_activity();
			} else {
				this.activities = [];
			}
		},
		order_parameters() {
			this.offset = 0;
			this.activities = [];
			if (this.member) {
				this.get_activity();
			}
		},
		member() {
			if (this.member !== this.$route.params.member) {
				if (this.member) {
					this.$router.push({name: 'members', params: { member: this.member}});
				} else {
					this.$router.push({name: 'members'});
				}
			}
		}
	},

	methods: {
		paragraph(text) {
			return text.split("\r\n");
		},

		async get_activity() {
			const results = await OpenData.getResults(this.$API_URL,this.parameters);
			this.last_count = results.length;
			this.activities = this.activities.concat(results);
		},

		async get_vote_types() {
			const parameters = {
				order_parameters: [{key: 'vote', direction: 'DESC'}],
				group_parameters: {
					select: ['vote'],
					group: ['vote']
				}
			}
			this.vote_types = await OpenData.getResults(this.$API_URL,parameters);
		},

		open_meeting(meeting,event) {
			if (!event.target || !event.target.nodeName || (event.target.nodeName !== "A")) {
				//this convoluted conditional ensures no NavigationDuplicated error 
				//because clicking on a link will also trigger the row based @click event
				//(if the user clicks on the link instead of anything else, it will cancel the @click method router navigation)
				this.$router.push({name: 'meeting', params: { meeting_id: meeting.meeting_id}});
			}
		},

		show_change_term() {
			this.show_terms = true;
		},

		update_date(new_date,date_name) {
			this[date_name] = new_date;
		},

		async get_committees() {
			let where_parameters = this.term_clause;
			let order_parameters = [{key: 'committee_name', direction: 'ASC' }];
			let group_parameters = {
				select: ['committee_name'],
				group: ['committee_name'],
			}
			const data = await OpenData.getResults(this.$API_URL,{ where_parameters, order_parameters, group_parameters });
			this.committees = data.map(row => row.committee_name);
		},


		async get_members() {
			let where_parameters = this.term_clause;
			let order_parameters = [{key: 'member_type', direction: 'DESC'}, {key: 'member', direction: 'ASC' }];
			let group_parameters = {
				select: ['member','member_type'],
				group: ['member','member_type'],
			}
			const data = await OpenData.getResults(this.$API_URL,{ where_parameters, order_parameters, group_parameters })
			this.members = data.map(row => row.member);
		},

		reset_selects() {
			this.get_committees();
			this.get_members();
		},

		order(column,direction) {
			this.column = column;
			this.direction = direction;
		},

		view_more() {
			this.offset += this.limit;
			this.get_activity();
		}
	}

}
</script>

